// import Header from './components/Header';
// import Footer from './components/Footer';
// import Para from './components/Para';
// import Heading from './components/Heading';
// import { Heading01 } from './components/Heading';
// import Heading2 from './components/Heading2';
// import { Heading201 } from './components/Heading2';
// import PurpleLabel from './components/PurpleLabel';
// import Result from './components/Result';
// import { Result01 } from './components/Result';
// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import './App.css'
// import axios from "axios";
// import { message } from "antd";
// import 'antd/dist/reset.css';


// // function formatDate(isoDate) {
// //   const date = new Date(isoDate);
// //   const day = String(date.getDate()).padStart(2, '0');
// //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
// //   const year = date.getFullYear();
// //   return `${day}-${month}-${year}`;
// // }

// function formatDate(inputDate) {
//   // Return empty string if the input is undefined, null, empty, or not a string
//   if (!inputDate || typeof inputDate !== "string") {
//     return "";
//   }

//   // Handle DD/MM/YYYY format
//   if (inputDate.includes("/")) {
//     const [day, month, year] = inputDate.split("/");
//     if (day && month && year) {
//       const isoDate = new Date(`${year}-${month}-${day}`); // Convert to ISO format
//       if (!isNaN(isoDate)) {
//         const formattedDay = String(isoDate.getDate()).padStart(2, "0");
//         const formattedMonth = String(isoDate.getMonth() + 1).padStart(2, "0");
//         const formattedYear = isoDate.getFullYear();
//         return `${formattedDay}-${formattedMonth}-${formattedYear}`;
//       }
//     }
//     return ""; // Return empty string if parsing fails
//   }

//   // Handle ISO format or other formats supported by the Date constructor
//   const date = new Date(inputDate);
//   if (!isNaN(date)) {
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   }

//   // Return empty string for invalid formats
//   return "";
// }


// const Page = () => {
//   const [error, setError] = useState(false)
//   const [kitInfo, setKitInfo] = useState({
//     "kitid": "loading",
//     "patientName": "loading",
//     "receiveddate": "loading",
//     "resultDate": "loading",
//     "result": [{ "Candida albicans": "Detected" },
//     { "Candida glabrata": "Not Detected" },
//     { "Candida tropicalis": "Detected - High" },
//     { "Candida parapsilosis": "Not Detected" },
//     { "Candida auris": "Not Detected" },
//     { "Candida krusei": "Not Detected" },],

//   })
//   const { id } = useParams()
//   // const download = async () => {
//   //   const pdf = new jsPDF();

//   //   // Select all pages by class name or specific selector
//   //   const pages = document.querySelectorAll('.page1');

//   //   for (let i = 0; i < pages.length; i++) {
//   //     const canvas = await html2canvas(pages[i], { scale: 2 });
//   //     const imgData = canvas.toDataURL('image/png');

//   //     // Add image to PDF
//   //     if (i > 0) {
//   //       pdf.addPage(); // Add a new page for subsequent pages
//   //     }
//   //     // pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // Adjust these values for page size
//   //     // pdf.addImage(imgData, 'PNG', 0, 0, 210, 297, null, null, null, null, { margin: 0 }); 
//   //     const pageWidth = pdf.internal.pageSize.getWidth();
//   //     const pageHeight = pdf.internal.pageSize.getHeight();
//   //     const imgWidth = 210;
//   //     const imgHeight = 297;

//   //     pdf.addImage(imgData, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight);

//   //     // Optional: to keep the size of the image as the page size
//   //     // pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
//   //   }

//   //   // Save the PDF
//   //   pdf.save('test-report.pdf');
//   // }
//   const download = async () => {
//     const hide = message.loading("Your report is downloading", 0);
//     // Hide the button by adding the class
//     const button = document.getElementById('downloadButton');
//     if (button) button.classList.add('hide-for-pdf');

//     const pdf = new jsPDF();
//     const pages = document.querySelectorAll('.page1');

//     for (let i = 0; i < pages.length; i++) {
//       const canvas = await html2canvas(pages[i], { scale: 2 });
//       const imgData = canvas.toDataURL('image/png');

//       if (i > 0) {
//         pdf.addPage();
//       }

//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const imgWidth = 210;
//       const imgHeight = 297;

//       pdf.addImage(imgData, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight);
//     }

//     // Save the PDF
//     pdf.save(`candida-report-${kitInfo.kitid}.pdf`);

//     // Show the button again by removing the class
//     if (button) button.classList.remove('hide-for-pdf');
//     hide()
//     message.success("Report has been downloaded Successfully!");
//   }

//   // useEffect(() => {
//   //     const getdata = async () => {
//   //         const urlencoded = new URLSearchParams();
//   //         urlencoded.append("_id", id);
//   //         // urlencoded.append("_id", "3310246537770");
//   //         const requestOptions = {
//   //             headers: {
//   //                 "Content-Type": "application/x-www-form-urlencoded",
//   //             },
//   //         };
//   //         try {
//   //             // Make the POST request with axios
//   //             const response = await axios.post(
//   //                 "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/candidadata",
//   //                 urlencoded, // Pass URLSearchParams directly as the body
//   //                 requestOptions
//   //             );

//   //             const result = response.data; // axios stores the response body in `data`
//   //             setKitInfo(result);
//   //             // download();
//   //           } catch (error) {
//   //             console.log("error", error);
//   //           } finally{
//   //         }
//   //     };

//   //     getdata();
//   //     // setTimeout(() => {
//   //     //     download();
//   //     // }, 200);
//   // }, []);

//   const getdata = async () => {

//     // alert(id)
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//     const urlencoded = new URLSearchParams();
//     urlencoded.append("_id", id);
//     // urlencoded.append("_id", "3310246537770");

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: urlencoded,
//       redirect: 'follow',
//     };

//     try {
//       // const response = await fetch("http://localhost:1337/viewwholereport", requestOptions);
//       const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata", requestOptions);
//       // const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewwholereport", requestOptions);
//       const result = await response.json();
//       // console.log(result)
//       // alert(result)
//       if (result === "error") {
//         setError(true)
//       } else {
//         setKitInfo(result);
//       }
//       // setMyResult(result.result);

//       // download();
//     } catch (error) {
//       console.log('error', error);
//       setError(true)
//     }
//   };
//   useEffect(() => {
//     getdata()
//   }, []);

//   useEffect(() => {
//     if (kitInfo.kitid != "loading") {
//       download()
//     }
//   }, [kitInfo])
//   return (
//     <div className='' >
//       <div className="" style={{display:"flex",alignItems:"center",flexDirection:"column"}}>
//       {/* <img src="/candida.png" alt="logo" className='w-96 mt-16 mb-12' style={{display:"flex" ,justifyContent:"center",display:"inline"}} />
//       <h2 className='text-xl font-bold'>{error ? "Kit Id doesn't exist!" : "Your Candida Report is Downloading"}</h2> */}
//       {/* <div style={{height:"1px", width:"2px", backgroundColor:"red" , overflow:"hidden"}}> */}
//       {/* page 1 */}
//       <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//         <Header />
//         <div className="flex-grow flex-col flex justify-center items-center">
//           <img src="/candida.png" alt="logo" className='w-2/3 mb-3' />
//           <div className="h-12 w-2/3 purple font-[600] mt-5 p-2 rounded-3xl text-4xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: '#6f4ea5' }}>Test Report</div>
//           <div className="h-12 w-2/3 font-[600] mt-5 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5', marginTop: '10px' }}>Kit Id : {kitInfo.kitid}</div>
//           <div className="h-4 w-2/3 font-[600] mt-2 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5' }}>Patient Name : {kitInfo.patientName}</div>
//           <button id='downloadButton' className="h-10 w-72 purple font-[600] mt-10 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: '#6f4ea5' }} onClick={download}>Download</button>
//           {/* <h2>Kit Id : {response.kitid}</h2> */}
//           {/* <h2>Patient Name : {response['Patient Name']}</h2> */}
//           {/* <button id='downloadButton' onClick={download} className='font-bold mt-3 text-2xl'>Download</button> */}
//         </div>
//         <Footer />
//       </div>

//       {/* page 2 */}
//       <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//         <Header />
//         <div className="flex-grow flex-col flex mx-10">
//           <Heading01 text={"Laboratory Report"}></Heading01>
//           <Para type={"report"}></Para>
//           <Heading01 text={"Candidate Test Report"}></Heading01>
//           <hr className='mt-2' />
//           <div className="flex justify-evenly mt-1">
//             <div className="font-bold font-poppins pb-[10px]">Sample Material:</div>
//             <div className="font-bold font-poppins pb-[10px]">Stool</div>
//             {/* <div className="font-bold font-poppins pb-[10px]">{response['Sample Material']}</div> */}
//           </div>
//           <hr className='mt-1' />
//           <div className="flex justify-evenly mt-1">
//             <div className="font-bold font-poppins pb-[10px]">Recieved Date:</div>
//             {/* <div className="font-bold font-poppins pb-[10px]">26-09-2021</div> */}
//             <div className="font-bold font-poppins pb-[10px]">{kitInfo.receiveddate!=null ? formatDate(kitInfo.receiveddate) : ""}</div>
//             <div className="font-bold font-poppins pb-[10px]">Completed Date:</div>
//             <div className="font-bold font-poppins pb-[10px]">{kitInfo.resultDate!= null ? formatDate(kitInfo.resultDate) : ""}</div>
//           </div>

//           {/* range  50 -- 135 -- 210 */}
//           <Heading201 t1={"Analyze"} t2={"Results"} t3={"Level"}></Heading201>
//           {/* <PurpleLabel text={"Yeast and Fungi"}></PurpleLabel> */}

//           {/* <Result t1={"Candida albicans"} t2={"Detected"} t3={135}></Result> */}
//           <Result01 t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result01>
//           <Result01 t1={"Candida glabrata "} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result01>
//           <Result01 t1={"Candida tropicalis "} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result01>
//           <Result01 t1={"Candida parapsilosis "} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result01>
//           <Result01 t1={"Candida auris "} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result01>
//           {/* <PurpleLabel text={"Intestinal Milieu"}></PurpleLabel> */}
//           <Result01 t1={"Candida krusei "} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result01>
//         </div>
//         <Footer />
//       </div>

//       {/* <Space></Space> */}

//       {/* page 3 */}
//       <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//         <Header />
//         <div className="flex-grow flex-col flex mx-10">
//           <Heading01 text={"Candida albicans"}></Heading01>
//           <Result01 t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result01>
//           <Para type={"Candida albicans"} result={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Para>
//           <Heading01 text={"Candida glabrata"}></Heading01>
//           <Result01 t1={"Candida glabrata"} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result01>
//           <Para type={"Candida glabrata"} result={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Para>


//         </div>
//         <Footer />
//       </div>
//       {
//         // console.log(kitInfo.result.find(item => item["Candida auris"])?.["Candida auris"])
//       }
//       {/* page 4 */}
//       <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//         <Header />
//         <div className="flex-grow flex-col flex mx-10">
//           <Heading01 text={"Candida tropicalis"}></Heading01>
//           <Result01 t1={"Candida Tropicalis"} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result01>
//           <Para type={"Candida Tropicalis"} result={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Para>
//           <Heading01 text={"Candida parapsilosis"}></Heading01>
//           <Result01 t1={"Candida parapsilosis"} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result01>
//           <Para type={"Candida parapsilosis"} result={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Para>

//         </div>
//         <Footer />
//       </div>
//       {/* page 5 */}
//       <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//         <Header />
//         <div className="flex-grow flex-col flex mx-10">
//           <Heading01 text={"Candida auris"}></Heading01>
//           <Result01 t1={"Candida auris"} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result01>
//           <Para type={"Candida auris"} result={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Para>
//           <Heading01 text={"Candida krusei"}></Heading01>
//           <Result01 t1={"Candida krusei"} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result01>
//           {/* <Para type={"Candida krusei"} result={"not Detected"}></Para> */}
//           <Para type={"Candida krusei"} result={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Para>

//         </div>
//         <Footer />
//       </div>
//       </div>

//       {/* </div> */}
//       <div style={{ height: "1px", width: "2px", backgroundColor: "red", overflow: "hidden" }}>
//         {/* page 1 */}
//         <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//           <Header />
//           <div className="flex-grow flex-col flex justify-center items-center">
//             <img src="/candida.png" alt="logo" className='w-2/3 mb-3' />
//             <div className="h-12 w-2/3 purple font-[600] mt-5 p-2 rounded-3xl text-4xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: '#6f4ea5', paddingBottom: '30px' }}>Test Report</div>
//             <div className="h-12 w-2/3 font-[600] mt-5 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5', marginTop: '10px' }}>Kit Id : {kitInfo.kitid}</div>
//             <div className="h-4 w-2/3 font-[600] mt-2 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5' }}>Patient Name : {kitInfo.patientName}</div>
//             {/* <h2>Kit Id : {response.kitid}</h2> */}
//             {/* <h2>Patient Name : {response['Patient Name']}</h2> */}
//             {/* <button id='downloadButton' onClick={download} className='font-bold mt-3 text-2xl'>Download</button> */}
//           </div>
//           <Footer />
//         </div>

//         {/* page 2 */}
//         <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//           <Header />
//           <div className="flex-grow flex-col flex mx-10">
//             <Heading text={"Laboratory Report"}></Heading>
//             <Para type={"report"}></Para>
//             <Heading text={"Candidate Test Report"}></Heading>
//             <hr className='mt-2' />
//             <div className="flex justify-evenly mt-1">
//               <div className="font-bold font-poppins pb-[10px]">Sample Material:</div>
//               <div className="font-bold font-poppins pb-[10px]">Stool</div>
//               {/* <div className="font-bold font-poppins pb-[10px]">{response['Sample Material']}</div> */}
//             </div>
//             <hr className='mt-1' />
//             <div className="flex justify-evenly mt-1">
//               <div className="font-bold font-poppins pb-[10px]">Recieved Date:</div>
//               {/* <div className="font-bold font-poppins pb-[10px]">26-09-2021</div> */}
//               <div className="font-bold font-poppins pb-[10px]">{kitInfo.receiveddate!= null ? formatDate(kitInfo.receiveddate) : null}</div>
//               <div className="font-bold font-poppins pb-[10px]">Completed Date:</div>
//               <div className="font-bold font-poppins pb-[10px]">{kitInfo.resultDate!= null ? formatDate(kitInfo.resultDate) : ""}</div>
//             </div>

//             {/* range  50 -- 135 -- 210 */}
//             <Heading2 t1={"Analyze"} t2={"Results"} t3={"Level"}></Heading2>
//             {/* <PurpleLabel text={"Yeast and Fungi"}></PurpleLabel> */}

//             {/* <Result t1={"Candida albicans"} t2={"Detected"} t3={135}></Result> */}
//             <Result t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result>
//             <Result t1={"Candida glabrata "} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result>
//             <Result t1={"Candida tropicalis "} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result>
//             <Result t1={"Candida parapsilosis "} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result>
//             <Result t1={"Candida auris "} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result>
//             {/* <PurpleLabel text={"Intestinal Milieu"}></PurpleLabel> */}
//             <Result t1={"Candida krusei "} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result>
//           </div>
//           <Footer />
//         </div>

//         {/* <Space></Space> */}

//         {/* page 3 */}
//         <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//           <Header />
//           <div className="flex-grow flex-col flex mx-10">
//             <Heading text={"Candida albicans"}></Heading>
//             <Result t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result>
//             <Para type={"Candida albicans"} result={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Para>
//             <Heading text={"Candida glabrata"}></Heading>
//             <Result t1={"Candida glabrata"} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result>
//             <Para type={"Candida glabrata"} result={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Para>


//           </div>
//           <Footer />
//         </div>
//         {
//           // console.log(kitInfo.result.find(item => item["Candida auris"])?.["Candida auris"])
//         }
//         {/* page 4 */}
//         <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//           <Header />
//           <div className="flex-grow flex-col flex mx-10">
//             <Heading text={"Candida tropicalis"}></Heading>
//             <Result t1={"Candida Tropicalis"} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result>
//             <Para type={"Candida Tropicalis"} result={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Para>
//             <Heading text={"Candida parapsilosis"}></Heading>
//             <Result t1={"Candida parapsilosis"} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result>
//             <Para type={"Candida parapsilosis"} result={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Para>

//           </div>
//           <Footer />
//         </div>
//         {/* page 5 */}
//         <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
//           <Header />
//           <div className="flex-grow flex-col flex mx-10">
//             <Heading text={"Candida auris"}></Heading>
//             <Result t1={"Candida auris"} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result>
//             <Para type={"Candida auris"} result={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Para>
//             <Heading text={"Candida krusei"}></Heading>
//             <Result t1={"Candida krusei"} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result>
//             {/* <Para type={"Candida krusei"} result={"not Detected"}></Para> */}
//             <Para type={"Candida krusei"} result={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Para>

//           </div>
//           <Footer />
//         </div>


//       </div>
//     </div>
//   );
// };

// export default Page;


import Header from './components/Header';
import Footer from './components/Footer';
import Space from './components/Space';
import Para from './components/Para';
import Heading from './components/Heading';
import { Heading01 } from './components/Heading';
import Heading2 from './components/Heading2';
import { Heading201 } from './components/Heading2';
import PurpleLabel from './components/PurpleLabel';
import Result from './components/Result';
import { Result01 } from './components/Result';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './App.css'
import axios from "axios";
import { message } from "antd";
import 'antd/dist/reset.css';

// function formatDate(isoDate) {
//   const date = new Date(isoDate);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// }

function formatDate(inputDate) {
  // Return empty string if the input is undefined, null, empty, or not a string
  if (!inputDate || typeof inputDate !== "string") {
    return "";
  }

  // Handle DD/MM/YYYY format
  if (inputDate.includes("/")) {
    const [day, month, year] = inputDate.split("/");
    if (day && month && year) {
      const isoDate = new Date(`${year}-${month}-${day}`); // Convert to ISO format
      if (!isNaN(isoDate)) {
        const formattedDay = String(isoDate.getDate()).padStart(2, "0");
        const formattedMonth = String(isoDate.getMonth() + 1).padStart(2, "0");
        const formattedYear = isoDate.getFullYear();
        return `${formattedDay}-${formattedMonth}-${formattedYear}`;
      }
    }
    return ""; // Return empty string if parsing fails
  }

  // Handle ISO format or other formats supported by the Date constructor
  const date = new Date(inputDate);
  if (!isNaN(date)) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Return empty string for invalid formats
  return "";
}

const Page = () => {

const {id} = useParams()
  const [primaryColor,setPrimaryColor] = useState("#724e9e");
  // const [primaryColor,setPrimaryColor] = useState("red");
  const [secondaryColor,setSecondaryColor] = useState("#4180b8");
  // const [secondaryColor,setSecondaryColor] = useState("green");
  // const [logo,setLogo] = useState("/logo.jpg");
  const [logo,setLogo] = useState("/blank.png");
  const [styleName,setStyleName] = useState("YourGutMap");
  const [header,setHeader] = useState()
  const [footer,setFooter] = useState()
  const [isUpdated,setIsUpdated] = useState(false)

  useEffect(() => {
    const updatedMap = {
      header: styleName === 'YourGutMap' ? "/design4.png" : "/blank.png",
      footer: styleName === 'YourGutMap' ? "/design3.png" : "/blank.png",
      logo: logo,
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      fontColor: primaryColor,
      header:header,
      footer:footer,
    };
    setReportStyle(updatedMap);
  }, [styleName, logo, primaryColor, secondaryColor]);
  
  
  
    useEffect(() => {
      const fetchReportStyle = async () => {
        try {
          // const response = await fetch("http://localhost:1337/getReportStyleByKit", {
          const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit", {
          // const response = await fetch("http://192.168.100.48:1338/getReportStyleByKit", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ kitId: id }), // Send the kit ID
          });
  
          const result = await response.json();
  
          if (response.ok && result.style) {
            // Update colors and logo if style data exists
            setPrimaryColor(result.style.primaryColor);
            setSecondaryColor(result.style.secondaryColor);
            setLogo(result.style.imageBase64);
            setStyleName(result.style.styleName);
            setHeader(result.style.header);
            setFooter(result.style.footer);
            setIsUpdated(true)
            // setStyleUpdated(true);
            // console.log(primaryColor)
          }
        } catch (error) {
          console.error("Error fetching report style:", error);
        }
      };
  
      fetchReportStyle();
    }, [id]); // Runs when the component mounts
  
  const Footer = () => {
    return (
      <div className="">
          <img src="/design2.jpg" alt="design2" className='h-28 w-11/12'/>
        </div>
    )
  }  
const Header = () => {
  return (
    <div className="flex justify-between">
        <img src="/logo.jpg" alt="logo" className='m-6 h-24 w-24'/>
        <img src="/design1.jpg" alt="design" className='h-32 w-11/12'/>
      </div>
  )
}
  const yourGutMap = {
    "logo":"/logo2.png",
    "primaryColor":"#724e9e",
    "secondaryColor":"#4180b8",
}
  const testme = {
    "logo":"/logotestme.png",
    "primaryColor":"#04BACF",
    "secondaryColor":"#BOBOBO",
}
const feelGut = {
    "logo":"/logofg.png",
    "primaryColor":"#724e9e",
    "secondaryColor":"#4180b8",
}
const [reportStyle,setReportStyle] = useState(yourGutMap)
  const [error, setError] = useState(false)
  const [kitInfo, setKitInfo] = useState({
    "kitid": "loading",
    "patientName": "loading",
    "receiveddate": "loading",
    "resultDate": "loading",
    "result": [{ "Candida albicans": "Detected" },
    { "Candida glabrata": "Not Detected" },
    { "Candida tropicalis": "Detected - High" },
    { "Candida parapsilosis": "Not Detected" },
    { "Candida auris": "Not Detected" },
    { "Candida krusei": "Not Detected" },],

  })

  // const download = async () => {
  //   const pdf = new jsPDF();

  //   // Select all pages by class name or specific selector
  //   const pages = document.querySelectorAll('.page1');

  //   for (let i = 0; i < pages.length; i++) {
  //     const canvas = await html2canvas(pages[i], { scale: 2 });
  //     const imgData = canvas.toDataURL('image/png');

  //     // Add image to PDF
  //     if (i > 0) {
  //       pdf.addPage(); // Add a new page for subsequent pages
  //     }
  //     // pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // Adjust these values for page size
  //     // pdf.addImage(imgData, 'PNG', 0, 0, 210, 297, null, null, null, null, { margin: 0 }); 
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidth = 210;
  //     const imgHeight = 297;

  //     pdf.addImage(imgData, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight);

  //     // Optional: to keep the size of the image as the page size
  //     // pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
  //   }

  //   // Save the PDF
  //   pdf.save('test-report.pdf');
  // }



  const download = async () => {
    const hide = message.loading("Your report is downloading", 0);
    // Hide the button by adding the class
    const button = document.getElementById('downloadButton');
    if (button) button.classList.add('hide-for-pdf');

    const pdf = new jsPDF();
    const pages = document.querySelectorAll('.page1');

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], { scale: 3 });
      const imgData = canvas.toDataURL('image/png');

      if (i > 0) {
        pdf.addPage();
      }

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = 210;
      const imgHeight = 297;

      pdf.addImage(imgData, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight,undefined, "FAST");
      // pdf.addImage(imgData, "JPEG", 5, 5, imgWidth, imgHeight, undefined, "FAST");
    }

    // Save the PDF
    pdf.save(`candida-report-${kitInfo.kitid}.pdf`);

    // Show the button again by removing the class
    if (button) button.classList.remove('hide-for-pdf');
    hide()
    message.success("Report has been downloaded Successfully!");
  }


  // const download = async () => {
  //   const hide = message.loading("Your report is downloading", 0);
  //   const button = document.getElementById("downloadButton");
  //   if (button) button.classList.add("hide-for-pdf");
  
  //   const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  //   const pages = document.querySelectorAll(".page1");
  
  //   for (let i = 0; i < pages.length; i++) {
  //     const canvas = await html2canvas(pages[i], { scale: 2 }); // ✅ High quality but not too big
  
  //     // ✅ Convert to JPEG with compression (0.6 - 0.7) to reduce size
  //     const imgData = canvas.toDataURL("image/jpeg", 0.6);
  
  //     if (i > 0) pdf.addPage();
  
  //     // ✅ Ensure image fits page with correct scaling
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidth = pageWidth;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
  //     pdf.addImage(imgData, "JPEG", 5, 5, imgWidth, imgHeight, undefined, "FAST"); // ✅ "FAST" compression mode
  //   }
  
  //   pdf.save(`candida-report-${kitInfo.kitid}.pdf`);
  
  //   if (button) button.classList.remove("hide-for-pdf");
  //   hide();
  //   message.success("Report has been downloaded Successfully!");
  // };
  
 
  const getdata = async () => {

    // alert(id)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("_id", id);
    // urlencoded.append("_id", "3310246537770");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    try {
      // const response = await fetch("http://localhost:1337/viewwholereport", requestOptions);
      const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata", requestOptions);
      // const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewwholereport", requestOptions);
      const result = await response.json();
      // console.log(result)
      // alert(result)
      if (result === "error") {
        setError(true)
      } else {
        setKitInfo(result);
      }
      // setMyResult(result.result);

      // download();
    } catch (error) {
      console.log('error', error);
      setError(true)
    }
  };
  useEffect(() => {
    getdata()
  }, []);

  // useEffect(() => {
    
  //   kitInfo.reportstyle === 'YourGutMap Report Style' ? setReportStyle(yourGutMap) : kitInfo.reportstyle === 'TestMe Report Style' ? setReportStyle(testme) :  setReportStyle(feelGut)
    
  // }, [kitInfo])
  

  useEffect(() => {
    // if (kitInfo.kitid != "loading") {
    if (isUpdated) {
      download()
    }
  }, [reportStyle])
  return (
    <div className='' >
      <div className="" style={{display:"flex",alignItems:"center",flexDirection:"column"}}>
      {/* <img src="/logo2.png" alt="logo" className='w-96 mt-16 mb-12' style={{display:"flex" ,justifyContent:"center",display:"inline"}} />
      <h2 className='text-xl font-bold'>{error ? "Kit Id doesn't exist!" : "Your Candida Report is Downloading"}</h2> */}
      {/* <div style={{height:"1px", width:"2px", backgroundColor:"red" , overflow:"hidden"}}> */}
      
      {styleName==='TestMe' ? <> <div className="page1"
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "297mm",
    width: "210mm",
  }}
>
  <div style={{ position: "relative", height: "100%", width: "100%" }}>
    {/* Background Image */}
    <img
      src="/bgtestme.jpg"
      alt="background"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover", // Or use "contain" depending on your needs
        zIndex: 0,
      }}
    />

    {/* Logo on top */}
    <img
      src="/testmelogo2.png"
      alt="logo"
      style={{
        position: "absolute",
        top: "4rem", // Adjust position as needed
        left: "2rem",
        width: "350px",
        zIndex: 1,
      }}
    />
    <h1 style={{
        position: "absolute",
        top: "30.3rem", // Adjust position as needed
        left: "3rem",
        // width: "650px",
        fontSize:"60px",
        zIndex: 2,
        color:"yellow"
      }}>Candida</h1>
    <h1 style={{
        position: "absolute",
        top: "35rem", // Adjust position as needed
        left: "3rem",
        // width: "650px",
        fontSize:"42px",
        zIndex: 2,
        color:"white"
      }}>Test Report</h1>
       <button
              style={{
                position: "absolute",
                top: "45rem", // Adjust position as needed
                left: "14rem",
                width: "350px",
                height: "50px",
                border: "none",
                borderRadius: "10px",
                background: "white",
                fontSize: "25px",
                color: `${reportStyle["primaryColor"]}`
              }}
              className=""
              id="downloadButton"
              onClick={download}
            >
              Download
            </button>
      <div className="" style={{
        position: "absolute",
        top: "60rem", // Adjust position as needed
        right: "2rem",
        // width: "50px",
        zIndex: 1,
        display:"flex",
        justifyContent:"space-between",
        width:"90%",
        height:"80px",
      }}>
        <div className="">
        <div className="" style={{height:"35px",width:"350px",background:"white",borderRadius:"20px",display:"flex",justifyContent:"start",paddingLeft:"20px",alignItems:"center",marginBottom:"10px",paddingBottom:"10px"}}>Name: {kitInfo.patientName}</div>
        <div className="" style={{height:"35px",width:"350px",background:"white",borderRadius:"20px",display:"flex",justifyContent:"start",paddingLeft:"20px",alignItems:"center",paddingBottom:"10px"}}>Kit ID: {kitInfo.kitid}</div>
      </div>
      <img
      src="/testmeend2.png"
      alt="logo"
      style={{
        // width:"250px"
      }}
    />
      
      </div>
  </div>
          </div>
          </> : null}
      
      
      
      
      
      
      {/* page 1 */}
      {styleName!=='TestMe' ?<><div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
        {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
        <div className="flex-grow flex-col flex justify-center items-center">
          {/* <img src="/logo2.png" alt="logo" className='w-2/3 mb-3' /> */}
          <img src={reportStyle.logo} width={'250px'} style={{marginBottom:reportStyle.logo === yourGutMap.logo ? "20px" :  "20px"}} alt='' />
          <div className="h-12 w-2/3 purple font-[600] mt-5 p-2 rounded-3xl text-4xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: reportStyle.primaryColor }}>Candida Test Report</div>
          <div className="h-12 w-2/3 font-[600] mt-5 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: reportStyle.primaryColor, marginTop: '10px' }}>Kit Id : {kitInfo.kitid}</div>
          <div className="h-4 w-2/3 font-[600] mt-2 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color:reportStyle.primaryColor }}>Patient Name : {kitInfo.patientName}</div>
          <button id='downloadButton' className="h-10 w-72 purple font-[600] mt-10 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: reportStyle.primaryColor }} onClick={download}>Download</button>
          {/* <h2>Kit Id : {response.kitid}</h2> */}
          {/* <h2>Patient Name : {response['Patient Name']}</h2> */}
          {/* <button id='downloadButton' onClick={download} className='font-bold mt-3 text-2xl'>Download</button> */}
        </div>
       {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
      </div></>:null}

      {/* page 2 */}
      <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
        {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
        <div className="flex-grow flex-col flex mx-10">
        {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
          <Heading01 text={"Laboratory Report"} color={reportStyle.primaryColor}></Heading01>
          <Para type={"report"} color={reportStyle.primaryColor}></Para>
          <Heading01 text={"Candidate Test Report"} color={reportStyle.primaryColor}></Heading01>
          <hr className='mt-2' />
          <div className="flex justify-evenly mt-1">
            <div className="font-bold font-poppins pb-[10px]">Sample Material:</div>
            <div className="font-bold font-poppins pb-[10px]">Stool</div>
            {/* <div className="font-bold font-poppins pb-[10px]">{response['Sample Material']}</div> */}
          </div>
          <hr className='mt-1' />
          <div className="flex justify-evenly mt-1">
            <div className="font-bold font-poppins pb-[10px]">Recieved Date:</div>
            {/* <div className="font-bold font-poppins pb-[10px]">26-09-2021</div> */}
            <div className="font-bold font-poppins pb-[10px]">{formatDate(kitInfo.receiveddate)}</div>
            <div className="font-bold font-poppins pb-[10px]">Completed Date:</div>
            <div className="font-bold font-poppins pb-[10px]">{formatDate(kitInfo.resultDate)}</div>
          </div>

          {/* range  50 -- 135 -- 210 */}
          <Heading201 t1={"Analyze"} t2={"Results"} t3={"Level"} color={reportStyle.primaryColor}></Heading201>
          {/* <PurpleLabel text={"Yeast and Fungi"}></PurpleLabel> */}

          {/* <Result t1={"Candida albicans"} t2={"Detected"} t3={135}></Result> */}
          <Result01 t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result01>
          <Result01 t1={"Candida glabrata "} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result01>
          <Result01 t1={"Candida tropicalis "} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result01>
          <Result01 t1={"Candida parapsilosis "} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result01>
          <Result01 t1={"Candida auris "} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result01>
          {/* <PurpleLabel text={"Intestinal Milieu"}></PurpleLabel> */}
          <Result01 t1={"Candida krusei "} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result01>
        </div>
        {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
       {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
      </div>

      {/* <Space></Space> */}

      {/* page 3 */}
      <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
        {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
        <div className="flex-grow flex-col flex mx-10">
        {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
          <Heading01 text={"Candida albicans"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result01>
          <Para type={"Candida albicans"} result={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} color={reportStyle.primaryColor}></Para>
          <Heading01 text={"Candida glabrata"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida glabrata"} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result01>
          <Para type={"Candida glabrata"} result={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} color={reportStyle.primaryColor}></Para>


        </div>
        {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
       {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
      </div>
      {
        // console.log(kitInfo.result.find(item => item["Candida auris"])?.["Candida auris"])
      }
      {/* page 4 */}
      <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
        {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
        <div className="flex-grow flex-col flex mx-10">
        {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
          <Heading01 text={"Candida tropicalis"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida Tropicalis"} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result01>
          <Para type={"Candida Tropicalis"} result={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} color={reportStyle.primaryColor}></Para>
          <Heading01 text={"Candida parapsilosis"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida parapsilosis"} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result01>
          <Para type={"Candida parapsilosis"} result={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} color={reportStyle.primaryColor}></Para>

        </div>
        {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
       {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
      </div>
      {/* page 5 */}
      <div className='flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
        {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
        <div className="flex-grow flex-col flex mx-10">
        {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
          <Heading01 text={"Candida auris"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida auris"} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result01>
          <Para type={"Candida auris"} result={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} color={reportStyle.primaryColor}></Para>
          <Heading01 text={"Candida krusei"} color={reportStyle.primaryColor}></Heading01>
          <Result01 t1={"Candida krusei"} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result01>
          {/* <Para type={"Candida krusei"} result={"not Detected"}></Para> */}
          <Para type={"Candida krusei"} result={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} color={reportStyle.primaryColor}></Para>

        </div>
        {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
       {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
      </div>
      </div>

      {/* </div> */}
      <div style={{ height: "1px", width: "2px", backgroundColor: "red", overflow: "hidden" }}>
        {/* page 1 */}
       {styleName!=='TestMe' ? <><div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
          {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
          <div className="flex-grow flex-col flex justify-center items-center">
            {/* <img src="/logo2.png" alt="logo" className='w-2/3 mb-3' /> */}
            <img src={reportStyle.logo} style={{width:"250px",marginBottom:"20px"}} alt='' />
            <div className="h-12 w-2/3 purple font-[600] mt-5 p-2 rounded-3xl text-4xl text-white flex justify-center items-center font-poppins" style={{ backgroundColor: reportStyle.primaryColor, paddingBottom: '30px',marginTop:"20px" }}>Candida Test Report</div>
            {/* <div className="h-12 w-2/3 font-[600] mt-5 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5', marginTop: '10px' }}>Kit Id : {kitInfo.kitid}</div>
            <div className="h-4 w-2/3 font-[600] mt-2 p-2 rounded-3xl text-2xl text-white flex justify-center items-center font-poppins" style={{ color: '#6f4ea5' }}>Patient Name : {kitInfo.patientName}</div> */}
            <h1 style={{color:reportStyle.primaryColor,fontSize:"20px",fontWeight:"bold",marginTop:"20px"}}>Kit Id : {kitInfo.kitid}</h1>
            <h1 style={{color:reportStyle.primaryColor,fontSize:"20px",fontWeight:"bold"}}>Patient Name : {kitInfo.patientName}</h1>
            {/* <button id='downloadButton' onClick={download} className='font-bold mt-3 text-2xl'>Download</button> */}
          </div>
         {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
        </div></>:null}

        {/* page 2 */}
        <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
          {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
          <div className="flex-grow flex-col flex mx-10">
          {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
            <Heading text={"Laboratory Report"} color={reportStyle.primaryColor}></Heading>
            <Para type={"report"} color={reportStyle.primaryColor}></Para>
            <Heading text={"Candidate Test Report"} color={reportStyle.primaryColor}></Heading>
            <hr className='mt-2' />
            <div className="flex justify-evenly mt-1">
              <div className="font-bold font-poppins pb-[10px]">Sample Material:</div>
              <div className="font-bold font-poppins pb-[10px]">Stool</div>
              {/* <div className="font-bold font-poppins pb-[10px]">{response['Sample Material']}</div> */}
            </div>
            <hr className='mt-1' />
            <div className="flex justify-evenly mt-1">
              <div className="font-bold font-poppins pb-[10px]">Recieved Date:</div>
              {/* <div className="font-bold font-poppins pb-[10px]">26-09-2021</div> */}
              <div className="font-bold font-poppins pb-[10px]">{formatDate(kitInfo.receiveddate)}</div>
              <div className="font-bold font-poppins pb-[10px]">Completed Date:</div>
              <div className="font-bold font-poppins pb-[10px]">{formatDate(kitInfo.resultDate)}</div>
            </div>

            {/* range  50 -- 135 -- 210 */}
            <Heading2 t1={"Analyze"} t2={"Results"} t3={"Level"} color={reportStyle.primaryColor}></Heading2>
            {/* <PurpleLabel text={"Yeast and Fungi"}></PurpleLabel> */}

            {/* <Result t1={"Candida albicans"} t2={"Detected"} t3={135}></Result> */}
            <Result t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result>
            <Result t1={"Candida glabrata "} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result>
            <Result t1={"Candida tropicalis "} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result>
            <Result t1={"Candida parapsilosis "} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result>
            <Result t1={"Candida auris "} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result>
            {/* <PurpleLabel text={"Intestinal Milieu"}></PurpleLabel> */}
            <Result t1={"Candida krusei "} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result>
          </div>
          {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
         {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
        </div>

        {/* <Space></Space> */}

        {/* page 3 */}
        <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
          {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
          <div className="flex-grow flex-col flex mx-10">
          {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
            <Heading text={"Candida albicans"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida albicans"} t2={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} t3={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]}></Result>
            <Para type={"Candida albicans"} result={kitInfo.result.find(item => item['Candida albicans'])?.["Candida albicans"]} color={reportStyle.primaryColor}></Para>
            <Heading text={"Candida glabrata"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida glabrata"} t2={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} t3={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]}></Result>
            <Para type={"Candida glabrata"} result={kitInfo.result.find(item => item['Candida glabrata'])?.["Candida glabrata"]} color={reportStyle.primaryColor}></Para>


          </div>
          {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
         {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
        </div>
        {
          // console.log(kitInfo.result.find(item => item["Candida auris"])?.["Candida auris"])
        }
        {/* page 4 */}
        <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
          {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
          <div className="flex-grow flex-col flex mx-10">
          {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
            <Heading text={"Candida tropicalis"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida Tropicalis"} t2={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} t3={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]}></Result>
            <Para type={"Candida Tropicalis"} result={kitInfo.result.find(item => item['Candida tropicalis'])?.["Candida tropicalis"]} color={reportStyle.primaryColor}></Para>
            <Heading text={"Candida parapsilosis"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida parapsilosis"} t2={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} t3={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]}></Result>
            <Para type={"Candida parapsilosis"} result={kitInfo.result.find(item => item['Candida parapsilosis'])?.["Candida parapsilosis"]} color={reportStyle.primaryColor}></Para>

          </div>
          {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
         {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
        </div>
        {/* page 5 */}
        <div className='page1 flex flex-col justify-between' style={{ height: '297mm', width: '210mm' }}>
          {/* {reportStyle.logo === yourGutMap.logo ? Header() :Space()} */}
        {<img src={reportStyle.header || '/blank.png' } alt="header" />}
          <div className="flex-grow flex-col flex mx-10">
          {styleName==='TestMe' ? <><img
      src="/testmemainlogo.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"30px",
        marginBottom:"30px",
        marginLeft:'500px'
      }}
    /></>:null}
            <Heading text={"Candida auris"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida auris"} t2={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} t3={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]}></Result>
            <Para type={"Candida auris"} result={kitInfo.result.find(item => item['Candida auris'])?.["Candida auris"]} color={reportStyle.primaryColor}></Para>
            <Heading text={"Candida krusei"} color={reportStyle.primaryColor}></Heading>
            <Result t1={"Candida krusei"} t2={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} t3={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]}></Result>
            {/* <Para type={"Candida krusei"} result={"not Detected"}></Para> */}
            <Para type={"Candida krusei"} result={kitInfo.result.find(item => item['Candida krusei'])?.["Candida krusei"]} color={reportStyle.primaryColor}></Para>

          </div>
          {styleName==='TestMe' ? <><img
      src="/testmeend.png"
      alt="logo"
      style={{
        width:"200px",
        marginTop:"0px",
        marginBottom:"30px",
        marginLeft:'550px'
      }}
    /></>:null}
         {/* {reportStyle.logo === yourGutMap.logo ? Footer() :null} */}
        {<img src={reportStyle.footer || '/blank.png' } alt="footer" />}
        </div>


      </div>
    </div>
  );
};

export default Page;







